import React, { useState, useEffect } from 'react';
import './completedProd.css';
import dateP from '../../assets/products/dateP.png';
import Header from '../../components/header';
import { connect } from 'react-redux';
import api from '../../api/api';
import { useParams, useHistory } from 'react-router-dom';
import reddate from '../../assets/products/reddate.png';
import Loader from '../../components/loader';
import { ErrorMessageHandling } from '../../components/error.js';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import config from '../../config.js';
import ApiURL from '../../api/url.js';

const CompletedProd = (props) => {
  const { t } = useTranslation();
  let { id } = useParams();
  const [subjectDetail, setsubjectDetail] = useState([]);
  const [loader, setloader] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [isFullScreen, setIsFullScreen] = useState(false);

  const item = props.product?.item;
  const youtubeUrls = item?.youtube_url ? JSON.parse(item.youtube_url) : [];
  const video_Url = item?.video_url;

  const handleVideoClick = async (url) => {
    try {
      let apiUrl = url;

      if (url.includes("youtube.com") || url.includes("youtu.be")) {
        let videoId = url.includes("youtu.be")
          ? url.split("youtu.be/")[1]?.split("?")[0]
          : new URL(url).searchParams.get("v");
        if (videoId) {
          apiUrl = `${ApiURL[config.env].YOUTUBE_URL}${videoId}?rel=0&modestbranding=1`;
        }
      } else if (url.includes("vimeo.com")) {
        const vimeoId = url.split("vimeo.com/")[1]?.split("?")[0];
        apiUrl = `https://player.vimeo.com/video/${vimeoId}`;
      } else if (url.endsWith(".mp4") || url.endsWith(".webm") || url.endsWith(".ogg")) {
        apiUrl = url;
      }

      setIframeUrl(apiUrl);
      setIsFullScreen(true);
    } catch (error) {
      console.error("Error making API call:", error);
    }
  };

  const closeVideo = () => {
    setIframeUrl("");
    setIsFullScreen(false);
  };

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.href = localStorage.getItem('feviconIcon');

    let request = {
      url: `/prod/student-product/item-type-description/${id}`,
      headers: { 'x-prod-inst-id': props.auth.institute_id },
    };
    setloader(true);
    api.getCustomAuth(request).then(data => {
      setsubjectDetail(data.data.result);
      setloader(false);
    }).catch((err) => {
      if (err && err.response && err.response.status === 403) {
        props.dispatch({ type: 'LOGOUT', msg: err.response.data.message });
      } else if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error(ErrorMessageHandling(err));
      }
    });
  }, []);

  const moment = require('moment');
  let dates = props.product.item.enrolled_date;
  let newdate = dates.split("T")[0];
  var dateString = moment(newdate).format('DD-MM-YYYY');

  let date = props.product.item.expire_on;
  let newdates = date ? date.split("T")[0] : '-';
  var dateStrings = moment(newdates).format('DD-MM-YYYY');

  const history = useHistory();

  const Course = (course) => {
    if (course && Array.isArray(course)) {
      return course.map((item, index) =>
        index < course.length - 1 ? item.course_type + ',' : item.course_type
      ).join('');
    } else {
      return '-';
    }
  };

  return (
    <>
      {loader && <Loader />}
      <Header />

      <div className="completed-container">
        {/* ---------------- Two-column layout ---------------- */}
        <div className="complete-div">
{console.log("url",props.product.item.logo_url,props)}
          {/* ---------------- LEFT COLUMN: Product + Videos ---------------- */}
          <div className="left-column">
            <div className="documentCard-complete">
            <div
  className="image-card22"
  style={{
    backgroundImage: `url(${props.product.item.photo_url || props.product.item.logo_url})`
  }}
>

                <div className="price">
                  {props.product.item.price === 0
                    ? <p>{t('products.free')}</p>
                    : <p>{props.product.item.price + " " + props.product.currency_code}</p>}
                </div>
              </div>
              <div className="product-heading">
                <span title={props.product.item.title}>{props.product.item.title} </span>
              </div>
              <div style={{ padding: "13px", overflow: "hidden", textOverflow: "ellipsis" }}>
                <span
                  title={props.product.item.about.replace(/<\/?[^>]+(>|$)/g, "")}
                  className="Exam-heading2">
                  {props.product.item.about.replace(/<\/?[^>]+(>|$)/g, "")}
                </span>
              </div>
              <div className="Category-heading1">
                <span>{props.auth.is_institute_type_school ? t('profile.standard')+":" : t('products.categoryOrCourse')} </span>
                <span title={Course(props.product.item.product_ecourse_maps)} className="Exam-heading2">
                  {Course(props.product.item.product_ecourse_maps)}
                </span>
              </div>
              <div className="Category-heading1">
                <span>{t('products.orderId')} </span>
                <div className="Exam-heading">{props.product.item.public_order_id}</div>
              </div>

              {props.product.item.is_enrolled &&
                <div className="card-prods2">
                  <div className="purchase-heading">
                    <span className="date-purchased"><img src={dateP} alt="" className="prod-date" /> {t('products.purchasedOn')} </span>
                    <span className="date">{dateString}</span>
                  </div>
                  <div className="partition-prod"></div>
                  <div className="purchase-heading">
                    {props.product.item.expired === false
                      ? <span><img src={reddate} alt="" className="prod-date" /> {t('products.expiryDate')} </span>
                      : <span><img src={reddate} alt="" className="prod-date" /> {t('products.expiredOn')} </span>}
                    <span className="date">{dateStrings}</span>
                  </div>
                </div>}
            </div>

            <button className="goback" onClick={() => { window.location = "../product" }}>{t('products.goBack')}</button>

            {/* ---------------- Videos below product ---------------- */}
         {/* ---------------- Videos below product ---------------- */}
{(youtubeUrls.length > 0 || video_Url) && (
  <div className="videos-wrapper">
    <h1 style={{fontWeight:"bold", marginLeft: "20px", fontSize: "20px" }}>{t('products.sample')}</h1>

    <div className="videos-carousel">
      { (youtubeUrls.length > 1 || video_Url) && (
        <button className="arrow left" onClick={() => {
          document.querySelector(".videos-scroll").scrollBy({ left: -300, behavior: "smooth" });
        }}>‹</button>
      )}

      <div className="videos-scroll">
        {youtubeUrls.map((url, index) => {
          let thumbnail = "";
          if (url.includes("youtube.com") || url.includes("youtu.be")) {
            let videoId = url.includes("youtu.be")
              ? url.split("youtu.be/")[1]?.split("?")[0]
              : new URL(url).searchParams.get("v");
            if (videoId) thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          } else if (url.includes("vimeo.com")) {
            thumbnail = "https://i.vimeocdn.com/video/default.jpg";
          } else {
            thumbnail = "/video-placeholder.png";
          }
          return (
            <div
              key={index}
              className="youtube-video"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleVideoClick(url); }}
            >
              <img src={thumbnail} alt={`Video ${index + 1}`} />
            </div>
          );
        })}

        {video_Url && (
          <div className="youtube-video" onClick={() => handleVideoClick(video_Url)}>
            <video>
              <source src={video_Url} type="video/mp4" />
            </video>
          </div>
        )}
      </div>

      { (youtubeUrls.length > 1 || video_Url) && (
        <button className="arrow right" onClick={() => {
          document.querySelector(".videos-scroll").scrollBy({ left: 300, behavior: "smooth" });
        }}>›</button>
      )}
    </div>
  </div>
)}

          </div>

          {/* ---------------- RIGHT COLUMN: Product Details ---------------- */}
          <div className="right-column">
            <h2 style={{fontWeight:"bold",fontSize: "20px" }}>{t('products.productDetails')}</h2>
            {subjectDetail.map((item, index) => (
              <div key={index} className="types">
                <div className="studyM">
                  <div className="dot"></div>
                  <div className="study-heading">{item.item_type}</div>
                </div>
                <div className="product-details">
                  <div className="div-para" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                  {item.item_type === "Study Material"
                    ? <div className="div-info">You can find study material by going to Study Material &gt; Purchased product &gt; Select Product</div>
                    : item.item_type === "Mock Test"
                      ? <div className="div-info">You can find and attempt the test by going to the My Tests &gt; Mock Test &gt; Select Product</div>
                      : item.item_type === "Live Class"
                        ? <div className="div-info">Live classes will be scheduled by your Institute and will be shown in live class Upcoming Section </div>
                        : item.item_type === "Classroom Classes"
                          ? <div className="div-info">Classroom classes will be scheduled by your Institute and will be shown in Timetable </div>
                          : item.item_type === "Printed Materials"
                            ? <div className="div-info">You can find printed material by going to Study Material &gt; Purchased product &gt; Select Product</div>
                            : item.item_type === "Video Lecture"
                              ? <div className="div-info">You can find video lectures by going to Study Material &gt; Purchased product &gt; Select Product</div>
                              : item.item_type === "Online Test"
                                ? <div className="div-info">You can find and attempt the test by going to the My Tests &gt; Online Test &gt; Select Product</div>
                                : <div></div>}
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* ✅ Video Modal */}
        {iframeUrl && (
          <div className={`video-container ${isFullScreen ? "fullscreen" : ""}`}
            style={{ marginTop: "20px", textAlign: "center" }}>
            <button
              onClick={closeVideo}
              style={{
                position: "absolute",
                top: "10px",
                right: "20px",
                background: "transparent",
                color: "white",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                zIndex: 2000,
              }}
            >✖</button>

            {iframeUrl.endsWith(".mp4") || iframeUrl.endsWith(".webm") || iframeUrl.endsWith(".ogg") ? (
              <video controls autoPlay style={{ width: "80%", height: "80%", borderRadius: "8px" }}>
                <source src={iframeUrl} />
              </video>
            ) : (
              <iframe
                width="80%"
                height="80%"
                src={iframeUrl}
                className="video-iframe"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video"
                style={{ borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.3)' }}
              ></iframe>
            )}
          </div>
        )}
      </div>

      <ToastContainer />
    </>
  );
};

const mapStateToProps = state => ({ auth: state.auth, product: state.product.data });
export default connect(mapStateToProps)(CompletedProd);
